module.exports = __webpack_public_path__ + "static/media/burger-header.5364c677.jpg";